// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sid-request-timeline-event__color-indicator{display:inline-block;width:8px;height:8px;vertical-align:middle;border-radius:50%}.sid-request-timeline-event__title{font-size:100%;font-weight:bold}.sid-request-timeline-event__date{font-size:90%;font-style:italic}", ""]);
// Exports
module.exports = exports;
